import { useEffect, useState } from "react";
import axios from "axios";
import { AlertTriangle } from "lucide-react";
import { Link as RouterLink } from "react-router-dom";
import { Button } from "./ui/button";
import { API } from "@/lib/api";
import { useTaal } from "@/contexts/TaalContext";
import { HERKOPPEL_ADRES, verlopenNamen } from "@/lib/herkoppel";

/**
 * GL201-2 (glasronde 0.9.201): een verlopen Google-toegang staat al bij het openen van de app
 * op het chatscherm, en niet pas na een poging in de chat. De vraag naar de koppelingen laat
 * de backend een verlopen toegang eerst vernieuwen (`services/toegangscontrole.py`); geeft
 * Google `invalid_grant`, dan staat de bron hier met de knop Opnieuw koppelen.
 * Zonder verlopen bron, of als de vraag mislukt, tekent dit niets.
 */
export default function VerlopenMelding() {
  const { t } = useTaal();
  const [namen, setNamen] = useState([]);
  useEffect(() => {
    let weg = false;
    (async () => {
      try {
        const r = await axios.get(`${API}/connections`);
        if (!weg) setNamen(verlopenNamen(r?.data));
      } catch {
        // Geen antwoord is geen melding: het scherm blijft zoals het was.
      }
    })();
    return () => { weg = true; };
  }, []);
  if (!namen.length) return null;
  return (
    <section role="status" data-testid="verlopen-melding"
      className="mb-4 rounded-lg border border-amber-500/50 bg-amber-500/10 p-3">
      {namen.map((naam) => (
        <div key={naam} className="flex flex-wrap items-center gap-2">
          <AlertTriangle className="h-4 w-4 shrink-0 text-amber-500" aria-hidden="true" />
          <p className="min-w-0 flex-1 basis-60 break-words text-sm">
            {t("De toegang tot {bron} is verlopen of ingetrokken bij Google. Koppel opnieuw om weer te kunnen lezen.", { bron: naam })}
          </p>
          <Button asChild size="sm" variant="outline" data-testid="verlopen-herkoppel">
            <RouterLink to={{ search: HERKOPPEL_ADRES }}>{t("{bron} opnieuw koppelen", { bron: naam })}</RouterLink>
          </Button>
        </div>
      ))}
    </section>
  );
}
